import querySearchAttendees from './querySearchAttendees';
import queryUser from './queryUser';
import queryTransactions from './queryTransactions';
import queryStats from './queryStats';
import queryUserAdminNotes from './queryUserAdminNotes';
import queryBookings from './queryBookings';
import queryPages from './queryPages';
import queryPage from './queryPage';
import queryEvents from './queryEvents';
import queryEvent from './queryEvent';
import queryTransfers from './queryTransfers';
import queryNotifications from './queryNotifications';
import queryNotification from './queryNotification';
import queryBareEvents from './queryBareEvents';
import queryPlaces from './queryPlaces';
import queryPlace from './queryPlace';
import queryRaceTasks from './queryRaceTasks';
import queryRaceTask from './queryRacetask';

export default {
  querySearchAttendees,
  queryBareEvents,
  queryUser,
  queryUserAdminNotes,
  queryEvents,
  queryEvent,
  queryTransactions,
  queryStats,
  queryRaceTasks,
  queryRaceTask,
  queryTransfers,
  queryNotification,
  queryNotifications,
  queryBookings,
  queryPages,
  queryPage,
  queryPlaces,
  queryPlace,
};



// WEBPACK FOOTER //
// ./src/graph/queries.js